/*
Purpose: Render children into a top-level React portal so modals always appear above app content.
Audience: Any component needing overlay dialogs.
What it does:
- Creates/uses a dedicated DOM node to mount modal content outside normal stacking contexts
- Ensures modals are not clipped by parents and respect global z-index
Interplay:
- Used by results modals and VehicleDetailsPanel to guarantee correct stacking
*/
import { createPortal } from 'react-dom';

export default function ModalPortal({ children }) {
  return createPortal(children, document.body);
}


